import React from "react";
import { isWebpSupported } from "react-image-webp/dist/utils";
import { URL_CONFIG } from "../../../../_constants/Config/URL_CONFIG";
import Card from "../CommonComponents/Card";
import HeadLines from "../CommonComponents/HeadLines";
import "./style.css";
import uatQRLink from "./../DesktopImages/Home/uatQRLink.png";
import liveQRLink from "./../DesktopImages/Home/liveQRLink.png";
import style from "./style.module.css";
const RightDownloadLink = (props) => {
  let pngImage = URL_CONFIG.IMG_URL + "arya2/download-bgd.png";
  let webpImage = URL_CONFIG.IMG_URL + "arya2/download-bgd.webp";

  return (
    <>
      <Card className={` boxRadius8  positionRelative  downloadComponent`}>
        <img
          src={isWebpSupported() ? webpImage : pngImage}
          className={` DownloadImageHeight w-100 boxRadius8`}
          alt=""
        />
        <div className="d-flex padding-left16 padding-top12 padding-right16 padding-bottom12 positionAbsolute DownloadPositionCSS justify-content-space-between align-items-center">
          <div className={`${style["text_width"]}`}>
            <HeadLines
              className="textColorWhite font-size14 line-height16 letterSpacing05 font-weight400 margin-bottom10"
              text={"arya.ag app is now available in your language!"}
            />
            <HeadLines
              className="textColorWhite font-size12 line-height14 letterSpacing05 font-weight400  "
              text={"Scan the QR to download app"}
            />
          </div>
          <div className="margin-right8">
            <img
              // src={downloadqr}
              alt=""
              src={
                window?.location?.href?.includes("uat") ? uatQRLink : liveQRLink
              }
              height={72}
              width={72}
            />
          </div>
        </div>
      </Card>
    </>
  );
};
export default RightDownloadLink;
